import firebase from 'firebase/compat/app';
import firebaseConfig from './conf/firebase';

export type IdTokenResult = firebase.auth.IdTokenResult;
export const firebaseApp = firebase.initializeApp(firebaseConfig);

